import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StoreProvider, rootStore } from "./store";
import "./styles/index.css";
import { routeTree } from "./routing";
import { getRouteTemplate } from "./routing/getRouteTemplate";
import { telemetry } from "./telemetry";

const root = ReactDOM.createRoot(document.getElementById("App") as HTMLElement);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      gcTime: 0,
      retry: false,
    },
  },
});

const router = createRouter({
  routeTree,
  context: {
    store: rootStore,
  },
  defaultOnCatch: (error, errorInfo) =>
    telemetry.trackClientError(
      error,
      "render",
      errorInfo.componentStack ?? undefined,
    ),
});

telemetry.initialize({
  getContext: () => ({
    language: rootStore.activeLanguage,
    province: rootStore.activeProvinceId,
    flow: rootStore.activeFlow,
    route: getRouteTemplate(router.state),
  }),
});

router.subscribe("onResolved", (event) => {
  if (event.pathChanged) telemetry.trackPageView();
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

root.render(
  <React.StrictMode>
    <StoreProvider value={rootStore}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StoreProvider>
  </React.StrictMode>,
);
